"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.frameDrPicasoInitializer = exports.frameHybridInitializer = exports.frameInitializer = void 0;
var features_1 = require("../../features");
Object.defineProperty(exports, "frameInitializer", { enumerable: true, get: function () { return features_1.frameInitializer; } });
Object.defineProperty(exports, "frameHybridInitializer", { enumerable: true, get: function () { return features_1.frameHybridInitializer; } });
Object.defineProperty(exports, "frameDrPicasoInitializer", { enumerable: true, get: function () { return features_1.frameDrPicasoInitializer; } });
//# sourceMappingURL=frame.initializers.js.map